import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const hideClearActionForPersonalTrashbin = isFeature('hide-clear-action-for-personal-trashbin') || false;
